import { ReactElement } from 'react';

import { ButtonVariant } from '@dreryk/react-components';

import { historicalVisitsTranslationKeys } from '../../translations';

import { StyledConfidentialAccessButton } from './HistoricalVisitConfidentialAccessButton.styled';

export const HistoricalVisitConfidentialAccessPendingButton = (): ReactElement => {
   return (
      <StyledConfidentialAccessButton
         testId={'confidentialAccessPending'}
         variant={ButtonVariant.SECONDARY}
         disabled
         compact
         label={historicalVisitsTranslationKeys.confidentialAccess.pending}
      />
   );
};
